/** Pure document/file helpers - no API calls */
const ALLOWED_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/zip',
  'application/x-zip-compressed',
  'text/plain',
  'text/csv',
];
const MAX_SIZE = 100 * 1024 * 1024;

export const validateFile = (file) => {
  const errors = [];
  const size = file?.file?.size ?? file?.size ?? 0;
  const type = file?.file?.type ?? file?.type ?? '';
  if (size > MAX_SIZE) errors.push(`File size exceeds maximum allowed size of ${MAX_SIZE / (1024 * 1024)}MB`);
  if (!ALLOWED_TYPES.includes(type)) {
    const typeLabel = type || 'unknown or not specified';
    errors.push(`File type "${typeLabel}" is not allowed`);
  }
  return { isValid: errors.length === 0, errors };
};

export const formatFileSize = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const getFileTypeCategory = (mimeType) => {
  if (!mimeType) return 'other';
  if (mimeType.startsWith('image/')) return 'image';
  if (mimeType.includes('pdf')) return 'pdf';
  if (mimeType.includes('word') || mimeType.includes('document')) return 'document';
  if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return 'spreadsheet';
  if (mimeType.includes('zip')) return 'archive';
  return 'other';
};
